import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';
import Pagination, { PaginationPropDef } from 'components/general/Pagination/Pagination';
import PaginationSkeleton from 'components/general/Pagination/PaginationSkeleton';
import getSiteQuery from 'state/selectors/getSiteQuery';
import getPageType from 'state/selectors/getPageType';
import getPayload from 'state/selectors/getPayload';

const SitePagination = compose<PaginationPropDef, {}>(
  // Pass in the query/type so we can preserve this info across page links
  connect(R.applySpec({
    type: getPageType,
    query: getSiteQuery,
    payload: getPayload,
  })),
  branch(
    R.either(
      R.pipe(
        R.prop('totalItems'),
        R.isNil,
      ),
      R.pathEq(['loading', 'state'], 'LOADING'),
    ),
    renderComponent(PaginationSkeleton),
  ),
)(Pagination);

export default SitePagination;
